import { Button, Checkbox, Col, Form, Input, Radio, Row, Select, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { Link, useParams, useLoaderData, useOutletContext, useNavigate } from 'react-router-dom';
import useWarehouseAPI from '../../apis/warehousesAPI';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { RxUpdate } from "react-icons/rx";
import EventEmitter from '../../../utils/eventEmitter';



const WarehouseChanges = () => {
  const warehouse = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(warehouse.name ? warehouse.name : '');
  const { create, update } = useWarehouseAPI();
  


  const onChangeName = (e) => setName(e.target.value);

  const save = () => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    create(data, success);
    // console.log(data);
  }

  const edit = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    update(warehouse.seo, data, success);
  };

  useEffect(() => {
    EventEmitter.subscribe('wareshouse_response', data => {
      // navigate('/inventory/warehouses/'+data);
    });
    
    return () => EventEmitter.unsubscribe('wareshouse_response');
  },[])

  return (
    <div className='container mx-auto' style={{ maxWidth: '1000px' }}>
      <div className='flex justify-between'>
        <div>
          <h3 className='font-bold'>
            <Link to={'/inventory/warehouses'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Warehouses</Link> / {params.action}
            <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={save} type='text' htmlType='button'
              disabled={warehouse.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={edit} type='text' htmlType='button'
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
          </h3>
          {warehouse.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
        </div>
        
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          name='name'
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Warehouse Name"
          value={name} 
          onChange={onChangeName}
        />
        <Form name="warehouses"
          form={form}
          labelAlign='left'
          labelCol={{ span: 7 }}
          labelWrap={true}
          initialValues={warehouse.name ? warehouse : {}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Row className='mt-5'>
            <Col lg={{ span: 11 }}>
              <Form.Item label='Short Name' name="short_name" className='font-bold mb-2 column' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal' placeholder='Akuse Warehouse' />
              </Form.Item>
              <Form.Item label='Value' name="value" className='font-bold mb-2 column' >
                <Input readOnly className='border-x-0 border-t-0 input-outline-none font-normal' />
              </Form.Item>
            </Col>
            <Col lg={{ span: 11, offset: 2 }}>
              <Form.Item label='Outlet' name="outlet_id" className='font-bold mb-2 column' required >
                <Input type='text' className='border-x-0 border-t-0 input-outline-none font-normal' />
              </Form.Item>
              <Form.Item label='Address' name="address" className='font-bold mb-2 column' required >
                <Input type='text' className='border-x-0 border-t-0 input-outline-none font-normal' />
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            className='mt-3'
            type='card'
            items={[
              {
                key: 1,
                label: 'Warehouse Configuration',
                children:
                  <Row>
                    <Col lg={{ span: 12 }}>
                      <Badge className="text-slate-500 text-xl bg-transparent	border-b-2 mb-3">SHIPMENTS</Badge>
                      <Form.Item label='Incoming Shipment' name="incoming_shipment" className='font-semibold text-gray-800 mb-3 column' required >
                        <Radio.Group >
                          <Radio value={'one_step'} className='font-normal text-md/[12px]'>Receive goods directly (1 Step)</Radio>
                          <Radio value={'two_steps'} className='font-normal text-md/[12px]'>Receive goods in input and then stock (2 Step)</Radio>
                          <Radio value={'three_steps'} className='font-normal text-md/[12px]'>Receive goods in input then quality and stock (3 Step)</Radio>
                        </Radio.Group>
                      </Form.Item>
                      <Form.Item label='Outgoing Shipments' name="outgoing_shipment" className='font-semibold text-gray-800 mb-2 column' required >
                        <Radio.Group >
                          <Radio value={'one_step'} className='font-normal text-md/[12px]'>Deliver goods directly (1 step)</Radio>
                          <Radio value={'two_steps'} className='font-normal text-md/[12px]'>Send goods in output and then deliver (2 steps)</Radio>
                          <Radio value={'three_steps'} className='font-normal text-md/[12px]'>Pack goods, send goods in output and then deliver (3 steps)</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    <Col lg={{span: 10, offset: 1}}>
                      <Badge className="text-slate-500 text-xl bg-transparent	border-b-2 mb-3">RESUPPLY</Badge>
                      <Form.Item label='Buy to Resupply' name='buy_to_resupply' valuePropName='checked'>
                        <Checkbox className='border-x-0 border-t-0 input-outline-none font-normal' />
                      </Form.Item>
                    </Col>
                  </Row>
              },
              // {
              //   key: 2,
              //   label: 'Technical Information',
              // }
            ]}
          />
        </Form>
      </div>
    </div>
  )
}

export default WarehouseChanges;